/**
 * The image types the assistant accepts; every provider behind the chat model tier reads them.
 * Gemini, the tier's last fallback, takes no GIF, so the composer redraws a pasted GIF as PNG.
 */
export const AI_CHAT_IMAGE_MEDIA_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;

export type AiChatImageMediaType = (typeof AI_CHAT_IMAGE_MEDIA_TYPES)[number];

export const AI_CHAT_MAX_IMAGES_PER_MESSAGE = 4;

/**
 * The client sends the whole transcript on every turn, so this bounds the images in one request as
 * well as in the conversation.
 */
export const AI_CHAT_MAX_IMAGES_PER_CONVERSATION = 6;

/**
 * Base64 characters in one image, about 750 KB decoded. A conversation's full allowance stays well
 * inside the server's 10 MB request body limit, which every turn's transcript must fit.
 */
export const AI_CHAT_MAX_IMAGE_BASE64_CHARS = 1_000_000;
